import { FakePlatformActionsConfig } from "./fakePlatformActions";

const config: FakePlatformActionsConfig = {
    authentication: {
        errorMessage: "",
        signinDelay: 1000,
    },
    disconnectionDelay: 50000,
    clientError: {
        show: true,
        delay: 40000,
        errorMessage: "Fake client error"
    },
    vsInstancesFetch: {
        errorMessage: "Can't get VS instances"
    },
    vsInstanceNew: {
        errorMessage: "Can't create new VS instances"
    },
    getScreenshot: {
        errorMessage: "Can't get screenshot"
    },
    recording: {
        result: "success",
        delayToProcessing: 3000,
        delayToDone: 6000,
        files: [
            "C:\\temp\\ETWLog1.etl",
            "C:\\temp\\ETWLog2.etl"
        ]
    },
    reserveNewTrackingId: {
        errorMessage: "Can't reserve tracking ID"
    },
    updateSettings: {
        errorMessage: ""
    },
    selectFiles: {
        errorMessage: "Can't select file"
    },
    viewFile: {
        errorMessage: "Can't view file"
    },
    upload: {
        errorMessage: "upload failed"
    }
};

export default config;
